
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/debtpulse",
      function () {
        return require("private-next-pages/products/debtpulse/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/debtpulse"])
      });
    }
  